import api from './api';

const eulaService = {
  /**
   * Get the current active EULA
   * This endpoint is public (no auth required)
   */
  getCurrentEula: async () => {
    try {
      const response = await api.get('/eula/current');
      return response.data;
    } catch (error) {
      if (error.response?.status === 404) {
        return null; // No active EULA
      }
      throw error;
    }
  },

  /**
   * Check if the current user has accepted the latest EULA
   * Returns the current EULA and user's acceptance status
   */
  getEulaStatus: async () => {
    const response = await api.get('/eula/status');
    return response.data;
  },

  /**
   * Accept the current EULA
   * @param {string} eulaId - ID of the EULA to accept
   */
  acceptEula: async (eulaId) => {
    const response = await api.post('/eula/accept', {
      eula_id: eulaId,
      // IP address and user agent are automatically captured on the backend
    });
    return response.data;
  },

  /**
   * Get the current user's EULA acceptance history
   */
  getEulaHistory: async () => {
    const response = await api.get('/eula/history');
    return response.data;
  },

  /**
   * Get all EULA versions (admin only)
   */
  getAllEulas: async () => {
    const response = await api.get('/eula/all');
    return response.data;
  },

  /**
   * Create a new EULA version (admin only)
   */
  createEula: async (eulaData) => {
    const response = await api.post('/eula/', eulaData);
    return response.data;
  },

  /**
   * Update an existing EULA (admin only)
   */
  updateEula: async (eulaId, eulaData) => {
    const response = await api.patch(`/eula/${eulaId}`, eulaData);
    return response.data;
  },
};

export default eulaService;
